import { Utilities as utilities } from "@truckdown/framework";
import { ThrottleResult } from "./ThrottleResult";

export class ThrottleResponse {
    constructor(json?: any) {
        if (json) {
            this.result = utilities.json.getEnumValue(json, "res", ThrottleResult, ThrottleResult.Quota);
            this.message = utilities.json.getStringValue(json, "msg", '');
        }
    }

    toJSON() {
        return {
            res: this.result,
            msg: this.message
        };
    }

    result: ThrottleResult = ThrottleResult.Quota;
    message: string = '';
}